<template>
  <div class="my-bill x-tablelist-view">
    <!-- 搜索行 -->
    <my-search-option
      class="my-bill-option"
      :layout="layout"
      :data="searchData"
      :isBreak="true"
      @clickSearch="search"
      @clear="clear"
    ></my-search-option>

    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        class="my-bill-table"
        ref="table"
        maxHeight="100%"
        layout="total, sizes, prev, pager, next"
        :hide-on-single-page="true"
        :emptyText="$t('HT.nodata')"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size="tableData.size"
        :page="tableData.page"
        @changePage="changePage"
        @changeSize="changeSize"
      ></ux-table>
    </div>

    <!-- 支付弹窗 -->
    <purchase-api
      :product="modalData.purchaseApi.product"
      :order-id="modalData.purchaseApi.orderId"
      :order-price="modalData.purchaseApi.orderPrice"
      :dead-time="modalData.purchaseApi.deadTime"
      v-if="modalData.purchaseApi.isShow"
      @close="modalData.purchaseApi.isShow = false"
    ></purchase-api>
  </div>
</template>

<script>
import mySearchOption from '@c/mySearchOption/mySearchOption';
import purchaseApi from '@/views/myline/modal/purchaseApi';

export default {
  components: {
    mySearchOption,
    purchaseApi
  },
  data() {
    return {
      id: this.$store.state.login.userData.id, // id
      ownerData: {}, //用户信息
      tableData: {
        // 表格数据
        totalSize: 0,
        size: 10, // 选择的页容量
        page: 1, // 当前页
        list: []
      },
      modalData: {
        purchaseApi: {
          isShow: false,
          product: null, // 产品信息
          orderId: '', // 订单id
          orderPrice: '', // 订单价格
          deadTime: 0 // 倒计时
        }
      },
      orderStatusOption: this.$opt.orderStatus, // 订单状态下拉框
      payTypeOption: this.$opt.payType, // 支付方式下拉框
      searchData: {
        orderNo: '', // 订单号
        productName: '', // 产品名称
        createdTime: [], // 订单生成时间
        payTime: [], // 支付完成时间
        payType: '', // 支付方式
        orderStatus: '' // 订单状态
      },
      countDownTimer: null, // 倒计时
      countDownList: [], // 倒计时数据
      saveSearchData: {}, // 保存搜索数据
      columns: [
        // 表头数据
        {
          prop: 'order_no',
          label: this.$t('HT.purchaseApi.orderNo'),
          tooltip: true,
          sortable: true,
          align: 'left',
          minWidth: 190
        },
        {
          prop: 'product_name',
          minWidth: 120,
          label: this.$t('HT.purchaseApi.productName'),
          tooltip: true,
          align: 'left'
        },
        {
          prop: 'rule_count',
          minWidth: 180,
          label: this.$t('HT.purchaseApi.productRule'),
          tooltip: true,
          sortable: true,
          align: 'left'
        },
        {
          prop: 'discount_money',
          minWidth: 110,
          label: this.$t('HT.orderOverview.ordermoney'),
          tooltip: true,
          sortable: true,
          align: 'left'
        },
        {
          prop: 'pay_date',
          label: this.$t('HT.purchaseApi.payDate'),
          tooltip: true,
          minWidth: 210,
          sortable: true,
          align: 'left',
          render: (h, row) => {
            return h('span', {}, row.pay_date || '-');
          }
        },
        {
          prop: 'created_date',
          label: this.$t('HT.purchaseApi.createdDate'),
          tooltip: true,
          sortable: true,
          align: 'left',
          minWidth: 210,
          render: (h, row) => {
            return h('span', {}, row.created_date || '-');
          }
        },
        {
          label: this.$t('HT.purchaseApi.payType'),
          tooltip: true,
          minWidth: 140,
          align: 'left',
          render: (h, row) => {
            const val =
              this.payTypeOption.find((item) => item.value === row.pay_type)?.label || '-';
            return h('span', {}, val);
          }
        },
        {
          label: this.$t('HT.orderOverview.status'),
          minWidth: 120,
          tooltip: true,
          align: 'left',
          render: (h, row) => {
            return h('span', {}, this.formatStatus(row));
          }
        },
        {
          label: this.$t('HT.operation'),
          minWidth: 140,
          tooltip: true,
          align: 'left',
          render: (h, row) => {
            if (row.status === 0) {
              return h(
                'ux-button',
                {
                  props: {
                    type: 'primary',
                    text: true
                  },
                  on: {
                    click: () => {
                      this.clickGotoPay(row);
                    }
                  }
                },
                this.$t('HT.mubill.goPay')
              );
            }
            return h('span', {}, '-');
          }
        }
      ],
      layout: [
        // 搜索项配置
        {
          label: this.$t('HT.purchaseApi.orderNo'),
          width: '272px',
          type: 'input',
          key: 'orderNo',
          hideBtn: true,
          placeholder: this.$t('HT.mubill.placeholder1')
        },
        {
          label: this.$t('HT.unbindApi.name'),
          width: '272px',
          type: 'input',
          key: 'productName',
          hideBtn: true,
          placeholder: this.$t('HT.rules.addProduct.name')
        },
        {
          label: this.$t('HT.purchaseApi.createdDate'),
          type: 'date',
          width: '320px',
          daterange: true,
          time: true,
          key: 'createdTime'
        },
        {
          label: this.$t('HT.purchaseApi.payDate'),
          width: '320px',
          type: 'date',
          daterange: true,
          time: true,
          key: 'payTime'
        },
        {
          label: this.$t('HT.purchaseApi.payType'),
          type: 'select',
          width: '272px',
          key: 'payType',
          hideBtn: true,
          options: this.$opt.payType,
          placeholder: this.$t('HT.pleaseSelect')
        },
        {
          label: '订单状态',
          type: 'select',
          width: '272px',
          key: 'orderStatus',
          hideBtn: true,
          options: this.$opt.orderStatus,
          placeholder: this.$t('HT.pleaseSelect')
        },
        {
          type: 'button',
          text: this.$t('HT.search'),
          show: true,
          event: 'clickSearch',
          spacing: '20px'
        },
        {
          type: 'button',
          text: this.$t('HT.clear'),
          button: 'info',
          show: true,
          event: 'clear',
          isText: true
        }
      ]
    };
  },
  mounted() {
    this.ownerData = this.$store.state.login.userData;
    // document.querySelector('.my-bill-table .ux-pagination').classList.remove('is-background');
  },
  created() {
    // this.getUserInfo();
    this.search();
  },
  destroyed() {
    this.countDownEnd();
  },
  methods: {
    getList() {
      const { size, page } = this.tableData;
      const { username } = this.ownerData;
      const { orderNo, productName, createdTime, payTime, payType, orderStatus } =
        this.saveSearchData;

      const params = {
        userName: username, // 下单用户
        orderNo, // 订单编号
        productName, // 产品名称
        orderStatus, // 订单状态
        payType, // 支付方式
        createStartTime: createdTime[0] || '', // 订单生成时间 - 开始时间
        createEndTime: createdTime[1] || '', // 订单生成时间 - 结束时间
        payStartTime: payTime[0] || '', // 支付完成时间 - 开始时间
        payEndTime: payTime[1] || '', // 支付完成时间 - 结束时间
        page, // 页码，最小为1
        size // 查询数量，最小为1，最大100条
      };
      this.$uxLoading.show();
      this.$api.order.getList(params).then((res) => {
        if (res.code == 10000) {
          const countDownList = {};
          this.countDownEnd();
          res.data.forEach((item) => {
            countDownList[item.order_no] = item.dead_time || 0;
          });
          this.countDownList = countDownList;
          this.tableData.list = res.data ?? [];
          this.tableData.totalSize = res.total_size || 0;
          this.$nextTick(() => {
            this.countDownStart();
          });
        }
      });
    },

    /**
     * 去支付
     */
    clickGotoPay(row) {
      const deadTime = this.countDownList[row.order_no]; // 倒计时时间

      const data = {
        product: {
          ...row
        },
        orderId: row.order_no,
        orderPrice: row.discount_money,
        deadTime,
        isShow: true
      };
      this.$set(this.modalData, 'purchaseApi', data);
    },

    /**
     * 搜索
     */
    search() {
      this.tableData.page = 1;
      this.saveSearchData = JSON.parse(JSON.stringify(this.searchData));
      this.getList();
    },

    /**
     * 清除
     */
    clear() {
      this.searchData.createdTime = [];
      this.searchData.payTime = [];
      this.searchData.orderNo = '';
      this.searchData.productName = '';
      this.searchData.payType = '';
      this.searchData.orderStatus = '';
      this.tableData.page = 1;
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.tableData.size = size;
      this.tableData.page = 1;
      this.getList();
    },

    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.tableData.page = page;
      this.getList();
    },

    /**
     * 获取订单状态格式
     */
    formatStatus(row) {
      const label = this.orderStatusOption.find((item) => item.value === row.status)?.label;
      let txt = '-';

      if (label) {
        if (row.status === 0) {
          // 待支付
          const countDown = this.countDownList[row.order_no];
          if (countDown <= 0) {
            // 找到对应数据修改状态 改为已关闭
            const idx = this.tableData.list.findIndex((item) => {
              return item.order_no === row.order_no;
            });
            this.tableData.list[idx].status = 4;
          } else {
            const m = Math.floor(countDown / 60); // 分
            const s = countDown % 60; // 秒
            txt = `${label}(${m}${this.$t('HT.orderOverview.minute')}${s}${this.$t(
              'HT.orderOverview.second'
            )})`;
          }
        } else {
          txt = label;
        }
      }
      return txt;
    },

    // 倒计时开始
    countDownStart() {
      this.countDownEnd();
      this.countDownTimer = setInterval(() => {
        const countDownList = this.countDownList;
        let hasNum = false; // 是否还在倒计时
        for (const key in countDownList) {
          if (countDownList.hasOwnProperty.call(countDownList, key)) {
            if (countDownList[key] > 0) {
              countDownList[key]--;
              hasNum = true;
            }
          }
        }
        if (!hasNum) {
          this.countDownEnd();
        }
      }, 1000);
    },

    // 清除倒计时
    countDownEnd() {
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.x-tablelist-view.my-bill {
  height: calc(100% - 60px);
  margin: 0;
  background: none;
  border: none;
  padding-left: 0;

  .my-bill-option {
    padding: 32px 40px 16px;
    margin-bottom: 24px;
    background: #fff;
    border-radius: 8px;
  }

  ::v-deep .my-bill-table .ux-pagination {
    text-align: right;
    padding: 40px 0 32px;

    .btn-next,
    .btn-prev {
      height: 32px;
      background: transparent;
    }

    .el-pager {
      .el-icon-more,
      .number,
      .btn-quicknext:hover {
        height: 32px;
        line-height: 32px;
        background: transparent;
      }
    }

    .el-pagination__sizes .el-select .el-input {
      .el-input__inner {
        border: none;
        background: transparent;
      }
    }
  }
}
</style>
